import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import MultiSelect from '../../components/Dropdowns/MultiSelect';
import { agentGroupUpsert, getTenantUsers } from '../../store/actions/tenantAction';
import { useDispatch, useSelector } from 'react-redux';
import { SHOW_SNACKBAR } from '../../utils/types';

function AddAgentGroup({ setIsShow, selectedAgentGroup, isEdit, onAdd }) {
    const { t } = useTranslation();
    let dispatch = useDispatch();
    const [agentGroup, setAgentGroup] = useState(selectedAgentGroup ?? {});
    const [allAgent, setAllAgent] = useState([]);
    const [selectedAgents, setSelectedAgents] = useState([]);
    const globalReducer = useSelector((state) => state.globalReducer);

    useEffect(() => {
        dispatch(getTenantUsers({
            tenantId: globalReducer.loginInfo?.tenantId,
            filter: [{
                property: "roles",
                operator: "IN",
                not: true,
                value: ["TENANT_SUPER_ADMIN"],
            }],
            criteria: { active: true }
        }, a => {
            setAllAgent(a.data ?? []);
            if (isEdit) {
                setSelectedAgents(a.data?.filter(item => selectedAgentGroup?.memberIds?.some(uid => uid === item.uid)));
            }
        }))
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (selectedAgents.length === 0) {
            dispatch({
                type: SHOW_SNACKBAR,
                payload: {
                    type: "error",
                    message: t("Please select at least one member."),
                    open: true,
                }
            });
            return;
        }
        agentGroup.memberIds = selectedAgents.map(agent => agent.uid);
        dispatch(agentGroupUpsert(agentGroup, a => {
            onAdd(a);
            setIsShow(false);
        }));
    };

    return (
        <form className="px-6 pb-6 pt-3 bg-white max-h-[90vh] overflow-auto" onSubmit={handleSubmit}>
            <div className="grid grid-cols-12 gap-3 w-full">
                <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label> {t('Group Name')}</label>
                    </div>
                    <input
                        type="text" required
                        placeholder={t("Enter Name")}
                        name="name"
                        value={agentGroup?.name}
                        onChange={(e) => setAgentGroup({ ...agentGroup, name: e.target.value })}
                        className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]"
                    />
                </div>
                <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label> {t('Add Member')}</label>
                    </div>
                    <MultiSelect list={allAgent?.filter(item => !selectedAgents.some(selected => selected.uid === item.uid))}
                        onSelect={(d) => {
                            selectedAgents.push(...d.filter(item => !selectedAgents.some(selected => selected.uid === item.uid)));
                            setSelectedAgents([...selectedAgents]);
                        }}
                        selected={[]}
                        labelField="name"
                        valueField="uid"
                        placeholder={t('Select Member')}
                    />
                </div>
                <div className="col-span-12">
                    <div className="text-midBlack text-[13px] font-normal mb-1">
                        <label> {t('Current Members')}</label>
                    </div>
                    <div className='h-10 bg-gray-100 rounded-md flex py-2 px-4 text-gray-500 text-sm'>
                        {t('Name')}
                    </div>
                    <div className='box-border shadow border border-gray-200 rounded-md h-[300px] overflow-y-auto mt-[-3px]'>
                        {selectedAgents?.map((agent, index) => <div className='flex'>
                            <div className='p-2 flex items-center gap-2'>
                                <div className='w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center'>
                                    <span className='text-gray-500 text-sm'>{agent?.name?.substring(0, 1)?.toUpperCase()}</span>
                                </div>
                                <span className='text-gray-700'>{agent?.name}</span>
                            </div>
                            <button type='button' className='ml-auto mr-5 text-red-500 hover:text-red-700' onClick={() => {
                                setSelectedAgents(selectedAgents.filter((_, i) => i !== index));
                            }}>
                                <i className='fas fa-trash'></i>
                            </button>
                        </div>)}
                        {selectedAgents.length === 0 &&
                            <div className='py-3 px-6 text-gray-500 text-sm'>
                                {t('No members added yet.')}
                            </div>}
                    </div>
                </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
                <button
                    type="button"
                    className="px-[16px] py-[6px] text-[#644d81] font-medium text-[14px] bg-[#ECF0F7] transition-all ease-in-out rounded cursor-pointer hover:bg-[#e4e8ef]"
                    onClick={() => setIsShow(false)}
                >
                    {t('Cancel')}
                </button>
                <button
                    type="submit"
                    className="min-w-[76px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary"
                >
                    {t('Save')}
                </button>
            </div>
        </form>
    )
}

export default AddAgentGroup